import React from "react";
import { Card, Typography, Space,} from "antd";
import { TrophyOutlined, StarOutlined, CheckCircleOutlined, PlusOutlined,} from "@ant-design/icons";

const { Title, Text } = Typography;

const StatCard = ({ title, value, icon, bg }) => {
  return (
    <Card
      bordered={false}  
      style={{
        borderRadius: 16,
        background: bg,
      }}
    >
      <Space direction="vertical" size={4} style={{ width: "100%" }}>
        <Space style={{ justifyContent: "space-between", width: "100%" }}>
          <Text strong>{title}</Text>
          {icon}
        </Space>

        <Title level={2} style={{ margin: 0 }}>
          {value}
        </Title>
      </Space>
    </Card>
  );
};

export default StatCard;